import React, { useEffect, useRef } from 'react';
import { Html5Qrcode, Html5QrcodeSupportedFormats } from 'html5-qrcode';

const SCANNER_ELEMENT_ID = 'employee-qr-scanner-region';

function QrScanner({ onDecode, onError }) {
  const onDecodeRef = useRef(onDecode);
  const onErrorRef = useRef(onError);
  onDecodeRef.current = onDecode;
  onErrorRef.current = onError;

  useEffect(() => {
    let cancelled = false;
    let started = false;
    let decoded = false;

    const scanner = new Html5Qrcode(SCANNER_ELEMENT_ID, {
      formatsToSupport: [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.CODE_128,
      ],
      verbose: false,
    });

    const config = { fps: 10, qrbox: { width: 250, height: 250 } };

    const handleSuccess = (decodedText) => {
      if (decoded) return;
      decoded = true;
      if (onDecodeRef.current) onDecodeRef.current(decodedText);
    };

    scanner
      .start({ facingMode: 'environment' }, config, handleSuccess, () => {})
      .then(() => {
        if (cancelled) {
          scanner.stop().catch(() => {});
          return;
        }
        started = true;
      })
      .catch((err) => {
        if (!cancelled && onErrorRef.current) onErrorRef.current(err);
      });

    return () => {
      cancelled = true;
      if (started) {
        scanner.stop().then(() => scanner.clear()).catch(() => {});
      }
    };
  }, []);

  return <div id={SCANNER_ELEMENT_ID} className="qr-scanner-region" />;
}

export default QrScanner;
